export default __webpack_public_path__ + "static/media/창의성.4686c011.png";